import ViewController from "core/views/view.controller";
import {Items} from "core/model/items.model";
import _ from "lodash/lodash";

export default class NewBookingResourceCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$q', '$ionicHistory', 'Services', 'Resources'];

    constructor() {
        super(...arguments);

        this.booking = null;
        this.resourceItems = null;
    }

    $onViewBeforeEnter() {
        this.loadBookingState();
        this.createResourceItems(this.booking.services, this.booking.resources);
    }

    prev() {
        this.saveBookingState();
        this.$ionicHistory.goBack();
    }

    next() {
        if (!this.resourceItems.hasSelected()) {
            return;
        }

        this.saveBookingState();
        this.toState('tab.new-booking-date');
    }

    loadBookingState() {
        this.booking = this.viewState('booking');
    }

    saveBookingState() {
        if (this.resourceItems) {
            this.booking.resources = this.resourceItems.selectedValues();
        }

        this.viewState('booking', this.booking);
    }

    createResourceItems(services, selectedResources) {
        this.loadResources(services).then(resources => {
            resources = _(resources).sortBy(resource => resource.name);
            this.resourceItems = Items.create(resources);

            if (selectedResources) {
                this.resourceItems.selectAllBy(selectedResources, 'id');
            }
        });
    }

    loadResources(services) {
        var defer = this.$q.defer();

        if (services && services.length > 0) {
            let resources = _(services)
                .flatMap(service => service.resources)
                .uniqBy(resource => resource.id)
                .value();

            defer.resolve(resources);
        } else {
            this.Resources.all().then(resources => {
                defer.resolve(resources);
            })
        }

        return defer.promise;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-resource/new-booking-resource.controller.js